import styled from "styled-components"
import LogoOpacity from '../../assets/logoOpacityDown.svg'

export default function NoData() {
    return (
        <Container>
            <ContentImage>
                <Image src={LogoOpacity} alt="Logo Óticas Mundial" />
            </ContentImage>
            <Message>
                Nenhum registro encontrado!
            </Message>
        </Container>
    )
}

const Container = styled.main`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 5px;
    height: 50vh;
`;

const ContentImage = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
`;

const Image = styled.img`
    height: 55px;
`;

const Message = styled.p`
    color: ${(props) => props.theme.colors.gray.gray_100};
    font-weight: 600;
`;
